import { AlertTriangle, RefreshCw } from 'lucide-react';
import { Container } from '../components/Container';

export default function AccessError() {
  const handleTryAgain = () => {
    window.location.reload();
  };

  return (
    <Container className="max-w-2xl">
      <div className="text-center py-12">
        {/* Icon */}
        <div className="mx-auto flex items-center justify-center w-16 h-16 rounded-full bg-red-100 dark:bg-red-900/20 mb-6">
          <AlertTriangle className="w-8 h-8 text-red-600 dark:text-red-400" />
        </div>

        {/* Heading */}
        <h1 className="text-2xl font-bold text-gray-900 dark:text-gray-100 mb-4">
          Something went wrong
        </h1>

        {/* Description */}
        <p className="text-gray-600 dark:text-gray-400 mb-8 leading-relaxed">
          We're having trouble loading your account details right now. This might be a temporary
          issue.
        </p>

        {/* Action Buttons */}
        <div className="flex flex-col sm:flex-row gap-4 justify-center items-center">
          <button
            onClick={handleTryAgain}
            className="inline-flex items-center px-6 py-3 border border-transparent text-base font-medium rounded-lg bg-[#E34290] text-white hover:bg-[#D63384] transition-colors duration-200 focus:outline-none focus:ring-2 focus:ring-offset-2 focus:ring-[#E34290] dark:focus:ring-offset-gray-900"
            data-ph-capture-attribute="btn-access-error-try-again"
          >
            <RefreshCw className="w-4 h-4 mr-2" />
            Try again
          </button>
        </div>

        {/* Additional help text */}
        <p className="text-sm text-gray-500 dark:text-gray-400 mt-8">
          If this problem persists, please contact our support team at{' '}
          <a
            href="mailto:support@jua.ai?subject=Access%20Error%20-%20Dashboard"
            className="text-[#E34290] hover:text-[#D63384] underline transition-colors duration-200"
          >
            support@jua.ai
          </a>{' '}
          and we'll help you get back on track.
        </p>
      </div>
    </Container>
  );
}
